import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GroupsLiqFilterRequest extends BaseServiceRequest {
    constructor() {
        super();
        super.addRequestUri("liqfilters.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GROUPS;
    }

    getMessageName() {
        return "LiqFilterResponse";
    }
}

export default GroupsLiqFilterRequest;
